import { HiArrowCircleUp } from 'react-icons/hi'

type UpgradeBadgeProps = {
  size?: number
}

export const UpgradeBadge = ({ size = 20 }: UpgradeBadgeProps) => <HiArrowCircleUp size={size} />
